import React from 'react'
import classes from './Templates.module.scss'
import Container from 'react-bootstrap/esm/Container'
import Row from 'react-bootstrap/esm/Row'
import Col from 'react-bootstrap/esm/Col'
import Section from '@/components/ui/Section'
import { Body, Cell, Head, HeaderCell, Row as TableRow, Table } from '@/components/ui/Table'
import { ReactComponent as CodeIcon } from '@/assets/icons/code.svg'
import { TemplateItem } from '@/app/routes/Templates/TemplateItem'
import { useCreatePreferredRouteTemplate } from './Templates.hooks'
import CreateRouteButton from '../Dashboard/CreateRouteButton'
import { useSuspenseQuery } from '@tanstack/react-query'
import { templatesQueries } from '@/features/templates'

export const Templates = () => {
  const { data: templates } = useSuspenseQuery(templatesQueries.list())
  const [createNewTemplate, isNewLoading] = useCreatePreferredRouteTemplate()

  return (
    <div className={classes.root}>
      <Container>
        <Row className={classes.row}>
          <Col>
            <Section className={classes.section}>
              <Section.Header title={'Templates'} icon={<CodeIcon />}>
                <CreateRouteButton title={'template'} onCreate={createNewTemplate} isLoading={isNewLoading} />
              </Section.Header>
              <Section.Content>
                <Table>
                  <Head>
                    <HeaderCell size={'80px'}>ID</HeaderCell>
                    <HeaderCell size={3}>Name</HeaderCell>
                    <HeaderCell>Language</HeaderCell>
                    <HeaderCell>Type</HeaderCell>
                    <HeaderCell>Status</HeaderCell>
                    <HeaderCell>Created at</HeaderCell>
                    <HeaderCell>Updated at</HeaderCell>
                    <HeaderCell size={'80px'} isCentered>
                      Delete
                    </HeaderCell>
                  </Head>
                  <Body>
                    {templates?.map((template) => <TemplateItem key={template.id} template={template} />)}

                    {templates!.length === 0 && (
                      <TableRow>
                        <Cell>No routes templates created yet</Cell>
                      </TableRow>
                    )}
                  </Body>
                </Table>
              </Section.Content>
            </Section>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
